import { ref, computed } from 'vue'

let nid = 1
function genId() { return 'node_' + (nid++) }
function genEdgeId() { return 'edge_' + (nid++) }

export const nodeTypes = {
  start:      { type: 0,  name: '开始',      iconFile: '0.png',  width: 70, height: 62, shape: 'rounded' },
  approval:   { type: 1,  name: '审批',      iconFile: '1.png',  width: 70, height: 62, shape: 'rect' },
  decision:   { type: 2,  name: '决策',      iconFile: '2.png',  width: 70, height: 62, shape: 'rect' },
  condition:  { type: 3,  name: '条件',      iconFile: '3.png',  width: 70, height: 70, shape: 'diamond' },
  split:      { type: 4,  name: '分流',      iconFile: '4.png',  width: 70, height: 62, shape: 'rect' },
  join:       { type: 5,  name: '合流',      iconFile: '5.png',  width: 70, height: 62, shape: 'rect' },
  notify:     { type: 6,  name: '邮件',      iconFile: '6.png',  width: 70, height: 62, shape: 'rect' },
  end:        { type: 8,  name: '结束',      iconFile: '8.png',  width: 70, height: 62, shape: 'rounded' },
  subprocess: { type: 35, name: '子流程',    iconFile: '35.png', width: 70, height: 62, shape: 'rect' },
  sqlplugin:  { type: 42, name: 'SQL插件',   iconFile: '42.png', width: 70, height: 62, shape: 'rect' },
  webplugin:  { type: 43, name: 'WebApi插件',iconFile: '43.png', width: 70, height: 62, shape: 'rect' }
}

export function createNode(typeKey, x, y) {
  const meta = nodeTypes[typeKey]
  if (!meta) return null
  return {
    id: genId(),
    nodeType: meta.type,
    typeKey,
    name: meta.name,
    x, y,
    width: meta.width,
    height: meta.height,
    props: getDefaultProps(meta.type)
  }
}

function getDefaultProps(nodeType) {
  const base = { stepName: '', description: '', taskNotify: '' }
  switch (nodeType) {
    case 0: return { ...base, stepName: '开始', remarkField: '', approvelForm: '', approvelPrintForm: '', customForm: '', useSave: false, functionBtn: '000000000000000', startTaskPermit: '0000000000', getTaskRule: '01', snapshot: false, mergerType: '0', mergerName: [], mergerLinkId: [], mergerLinkName: [], attachmentPerm: '000', attachmentType: '0', attachmentExt: '', attachmentSizeType: '0', attachmentSize: '', opinionPerm: '0', operateDoc: '', operateDocName: '', notifyChannels: '0000', notifyTemplateType: 'default', notifyTemplateTitle: '', notifyTemplateContent: '', mailTemplateTitle: '', mailTemplateContent: '', dingtalkTemplateTitle: '', dingtalkTemplateContent: '', wecomTemplateTitle: '', wecomTemplateContent: '', ccList: [], customNotifyList: [], eventList: [] }
    case 1: return { ...base, stepName: '审批', approvelForm: '', approvelPrintForm: '', customForm: '', useSave: false, approvelTaskPermit: '00000000000000', nodeGroup: '', getTaskRule: '01', functionBtn: '00000000000000', processingStrategy: '1', agreeButton: '', agreerule: '0000', agreeType: 0, snapshot: false, timeoutDate: '', timeoutCalendar: '', timeoutProcess: '', attachmentPerm: '000', opinionPerm: '0', allowBat: '', operateDoc: '', localPrintForm: '', needRemark: false, allowAgent: false, directSend: false, allowMultiExpression: '', retrieveRule: 'always', recedeStep: '', attachmentTypeLimit: '', attachmentSizeLimit: '', attachmentSinglePerm: false, notifyChannels: '000', notifyTemplateType: 'default', notifyTemplateTitle: '', notifyTemplateContent: '', mailTemplateTitle: '', mailTemplateContent: '', dingtalkTemplateTitle: '', dingtalkTemplateContent: '', wecomTemplateTitle: '', wecomTemplateContent: '', ccList: [], eventList: [], handlers: [], customNotifyList: [] }
    case 2: return { ...base, stepName: '决策', approvelForm: '', approvelTaskPermit: '00000000000000', functionBtn: '00000000000000', getTaskRule: '01', notifyChannels: '000', mergerType: '0', mergerName: '', mergerLinkId: '', mergerLinkName: '', handlers: [], ccList: [], eventList: [] }
    case 3: return { ...base, stepName: '条件', conditionType: '', fromCode: '', sqlCode: '', initiatorCode: '', approvelForm: '', approvelTaskPermit: '', conditionRules: [], initiatorRules: [] }
    case 4: return { ...base, stepName: '分流', splitType: '' }
    case 5: return { ...base, stepName: '合流', splitSourceId: '', unionType: 0, throughField: '', throughTicket: '' }
    case 6: return { ...base, stepName: '邮件', approvelForm: '', approvelTaskPermit: '00000000000000', functionBtn: '00000000000000', description: '', notifyChannels: '0000', handlers: [], receiverList: [], customNotifyList: [] }
    case 8: return { ...base, stepName: '结束', endType: '', notifyChannels: '000', handlers: [], customNotifyList: [] }
    case 35: return { ...base, stepName: '子流程', subProcess: '', callType: '', subFlow: undefined }
    case 42: return { ...base, stepName: 'SQL插件', dataSource: 'Default', strSQL: '' }
    case 43: return { ...base, stepName: 'WebApi插件', dataSource: 'get', strSQL: '', repeatVar: '' }
    default: return base
  }
}

/** 根据已加载的节点列表同步 nid，避免新增节点时 ID 冲突 */
export function syncNid(nodes) {
  if (!nodes || nodes.length === 0) return
  let maxN = 0
  for (const n of nodes) {
    const m = n.id?.match(/^node_(\d+)$/)
    if (m) maxN = Math.max(maxN, parseInt(m[1]))
  }
  if (maxN >= nid) nid = maxN + 1
}

export function defaultEdgeProps() {
  return {
    showName: '',          // 步骤名（内部标识）
    displayName: '',       // 显示名（画布上显示的文字）
    needRemark: false,
    linkCondition: '', linkConditionCode: '',
    conditionBranch: '1',  // '1'=条件成立, '0'=条件不成立（仅条件节点源有效）
  }
}

export function useFlowState() {
  const nodes = ref([])
  const edges = ref([])
  const selectedId = ref(null)        // 节点选中 ID
  const selectedEdgeId = ref(null)    // 连线选中 ID
  const connectingFrom = ref(null)

  const selectedNode = computed(() => nodes.value.find(n => n.id === selectedId.value))
  const selectedEdge = computed(() => edges.value.find(e => e.id === selectedEdgeId.value))

  function addNode(typeKey, x, y) {
    const node = createNode(typeKey, x, y)
    if (!node) return
    nodes.value.push(node)
    selectedId.value = node.id
    selectedEdgeId.value = null
  }

  function removeNode(id) {
    nodes.value = nodes.value.filter(n => n.id !== id)
    edges.value = edges.value.filter(e => e.from !== id && e.to !== id)
    if (selectedId.value === id) selectedId.value = null
  }

  function moveNode(id, x, y) {
    const node = nodes.value.find(n => n.id === id)
    if (node) { node.x = x; node.y = y }
  }

  function selectNode(id) { selectedId.value = id; selectedEdgeId.value = null }
  function clearSelection() { selectedId.value = null; selectedEdgeId.value = null; connectingFrom.value = null }

  function selectEdge(id) { selectedEdgeId.value = id; selectedId.value = null }
  function clearEdgeSelection() { selectedEdgeId.value = null }

  function addEdge(fromId, toId) {
    if (fromId === toId) return
    if (edges.value.find(e => e.from === fromId && e.to === toId)) return
    // 支持同一源节点多条出线，不再覆盖已有连线
    const srcNode = nodes.value.find(n => n.id === fromId)
    if (srcNode && srcNode.nodeType === 3) {
      // 条件节点：自动按分支数分配条件成立/不成立
      const existingBranches = edges.value.filter(e => e.from === fromId)
      const branchVal = existingBranches.length === 0 ? '1' : '0'
      edges.value.push({ id: genEdgeId(), from: fromId, to: toId, label: '', waypoints: [], props: { ...defaultEdgeProps(), conditionBranch: branchVal } })
    } else {
      edges.value.push({ id: genEdgeId(), from: fromId, to: toId, label: '', waypoints: [], props: { ...defaultEdgeProps(), showName: '同意', displayName: '同意' } })
    }
  }

  function removeEdge(id) {
    edges.value = edges.value.filter(e => e.id !== id)
    if (selectedEdgeId.value === id) selectedEdgeId.value = null
  }

  function startConnect(id) { connectingFrom.value = id; selectedEdgeId.value = null }
  function finishConnect(toId) {
    if (connectingFrom.value && connectingFrom.value !== toId) {
      addEdge(connectingFrom.value, toId)
    }
    connectingFrom.value = null
  }
  function cancelConnect() { connectingFrom.value = null }

  function deleteSelected() {
    if (selectedEdgeId.value) {
      removeEdge(selectedEdgeId.value)
    } else if (selectedId.value) {
      removeNode(selectedId.value)
    }
  }

  function updateNodeProp(id, key, value) {
    const node = nodes.value.find(n => n.id === id)
    if (node) node.props[key] = value
  }

  function updateEdgeProp(id, key, value) {
    const edge = edges.value.find(e => e.id === id)
    if (edge) {
      if (!edge.props) edge.props = defaultEdgeProps()
      edge.props[key] = value
    }
  }

  function getSnapshot() {
    return {
      nodes: JSON.parse(JSON.stringify(nodes.value)),
      edges: JSON.parse(JSON.stringify(edges.value)),
      nid
    }
  }

  function restoreSnapshot(snap) {
    nodes.value = snap.nodes
    edges.value = snap.edges
    nid = snap.nid
  }

  return {
    nodes, edges, selectedId, selectedEdgeId, selectedNode, selectedEdge, connectingFrom,
    addNode, removeNode, moveNode, selectNode, clearSelection,
    selectEdge, clearEdgeSelection,
    addEdge, removeEdge, startConnect, finishConnect, cancelConnect, deleteSelected,
    updateNodeProp, updateEdgeProp, getSnapshot, restoreSnapshot,
    nodeTypes, defaultEdgeProps
  }
}
